import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationStart, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {NetscopeUiService} from "@app/services/netscope-ui.service";
import {combineLatest, take} from "rxjs";
import {FlowDetail, TemporalParameter} from "@app/netscope/model/data-models";


@Component({
    standalone: false,
  selector: 'app-netscope-threat-center',
  templateUrl: './netscope-threat-center.component.html',
  styleUrls: ['./netscope-threat-center.component.css']
})
export class NetscopeThreatCenterComponent implements OnInit, OnDestroy {

  isLoading = false;
  failureMode = false;
  temporalParameter: TemporalParameter;

  // Details datagrid's config
  flowDetails: FlowDetail[] = [];

  constructor(private netscopeUiService: NetscopeUiService, private route: Router, public translocoService: TranslocoService) {
  }

  ngOnInit(): void {

    this.netscopeUiService.setViewLabel("threats_center.name");
    this.netscopeUiService.setIconShape("bug");

    this.reloadData();

    this.route.events.subscribe((event) => {
      if (event instanceof NavigationStart && event.url !== "/dashboard") {
        console.log(event);
        this.ngOnDestroy();
      }
    });

    this.netscopeUiService.selectedResourcesChangeEmitter.subscribe((comboboxSelectionItem) => {
      this.reloadData();
    });

    this.netscopeUiService.selectedDateChangeEmitter.subscribe(([startTime, endTime, timeResolution]) => {
      this.temporalParameter = {
        startTime: startTime,
        endTime: endTime,
        timeResolution: timeResolution,
        timeSelection: "custom"
      };
      this.netscopeUiService.temporalParametersSubject.next(this.temporalParameter);
      // this.updateTemporalParameterHighlighting();
    });

    this.netscopeUiService.temporalParametersSubject.subscribe((newTemporalParameters) => {
      this.temporalParameter = newTemporalParameters;
    });

    this.netscopeUiService.duckDbRefinedDataSubject.subscribe((dashboardData) => {
      this.reloadData();
    })

    this.netscopeUiService.dashboardGraphDataSubject.subscribe((dashboardData) => {
      this.reloadData();
    })
  }

  ngOnDestroy = () => {
  }

  reloadData = () => {
    this.netscopeUiService.setLoadingState(true, "dashboard");
    console.log("dashboardData.reloadData()");

    combineLatest([
      this.netscopeUiService.dashboardGraphDataSubject,
      this.netscopeUiService.duckDbRefinedDataSubject,
      this.netscopeUiService.threatsFlowDetailsSubject]).pipe(
      take(1),
    ).subscribe(([dashboardGraphData, duckDbData, flowDetails]) => {
      console.log("Dashboard got duckdbData");
      this.flowDetails = flowDetails;
      this.netscopeUiService.setLoadingState(false, "dashboard");
    });
  }

  switchFocus = (vm) => {
    this.netscopeUiService.switchFocus(vm);
  }
}

